module.exports = __webpack_public_path__ + "static/img/background.3e78263c.svg";